import { LOADING, TEAM_USERS, TEAMS } from "../actionType/teamManagementType";

const initialState = {
  loading: true,
  teams: [],
  teamUsers: [],
};

const teamManagementReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOADING:
      return { ...state, loading: payload };
    case TEAMS:
      return { ...state, teams: payload };
    case TEAM_USERS: 
      return { ...state, teamUsers: payload };
    default:
      return state;
  }
};

export default teamManagementReducer;
